import React from "react";
import { Font, StyleSheet, Text, View } from "@react-pdf/renderer";
import cambria from "../../../../font/Cambria.ttf";

Font.register({
  family: "Cambria",
  src: cambria,
  fontStyle: "normal",
  fontWeight: "normal",
});

const styles = StyleSheet.create({
  container: {
    textAlign: "center",
    width: "100%",
    marginTop: 50,
  },
  text: {
    color: "#000000",
    fontSize: 15,
    fontFamily: "Cambria",
    textDecoration: "underline",
  },
});

const Title = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>CONSTANCIA DE TRABAJO</Text>
    </View>
  );
};

export default Title;
